import { useState, useEffect } from 'react';

/**
 * issue #109: 単一クロック。active 中だけ 1 本の interval で現在時刻 (epoch ms) を返す。
 * active=false / unmount では interval を張らない (idle で毎秒 re-render しない)。
 */
export function useNow(active: boolean, intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    setNow(Date.now()); // active 化直後に即同期
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [active, intervalMs]);
  return now;
}
